/** Prefix of the error reported when a scoped `t` is asked for a key its scope does not define. */
export const SCOPED_MISS_MESSAGE_PREFIX = `Missing scoped i18n entry`;
